import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted chimney range hood, authored at its true
// mounting height: a 0.6 m steel canopy at y = 1.5 over a stove, with a
// narrowing duct rising to y = 2.4 against the wall on -Z.
const STEEL = "#aab2b8";
const STEEL_DARK = "#9aa2a8";
const MATTE_BLACK = "#2e2e30";

export const rangeHood = defineModel({
  id: "range-hood",
  batchId: "modern",
  name: "Range hood",
  tags: ["modern", "interior", "appliance", "kitchen", "ventilation"],
  summary: "A wall-mounted steel chimney hood with a duct rising to the ceiling.",
  tiles: { w: 1, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // canopy slab (bottom at y = 1.5, back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(0.6, 0.08, 0.5), color: STEEL, position: [0, 1.54, -0.05] },
      // control strip along the canopy front edge
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.04), color: MATTE_BLACK, position: [0, 1.53, 0.19] },
      // tapering transition above the canopy
      { geometry: new THREE.BoxGeometry(0.42, 0.14, 0.36), color: STEEL_DARK, position: [0, 1.65, -0.11] },
      // chimney duct rising to y = 2.4
      { geometry: new THREE.BoxGeometry(0.26, 0.68, 0.24), color: STEEL, position: [0, 2.06, -0.17] },
    ];
  },
  animations: [],
});
